<template>
  <div class="welcome">
    <HeroSection theme="home/welcome">
      <div class="row justify-content-lg-between align-items-lg-center mb-5">
        <div class="col-lg-7 mb-7 mb-lg-0 pb-3">
          <!-- Info -->
          <h1 class="font-size-5 font-size-md-down-5 text-white font-weight-bold text-warning" style="font-size: 3.6rem">
            Remortgage &amp; Save
          </h1>
          <p class="text-white-70 h2" style="line-height: 1.25">
            We can help you save money <span class="text-warning">every month</span> by finding you a better remortgage deal.
          </p>
          <p class="text-white-70 h3 mt-3 mb-4">
            It only takes a few minutes to find out!
          </p>
          <p>
            <a href="#introduction-to-mortgagewatch" 
               class="btn btn-light" v-smooth-scroll>Tell me more...</a>
          </p>
        </div>
        <div class="col-lg-5 d-none d-lg-inline-block">
          <!-- SVG Icon -->
          <figure class="ie-knowledgebase-community-2">
            <img class="js-svg-injector w-90" src="/assets/cmc/svg/illustrations/knowledgebase-community-2.svg" alt="SVG Illustration"
                 data-parent="#SVGpricingHero">
          </figure>
          <!-- End SVG Icon -->
        </div>
      </div>
    </HeroSection>
  </div>
</template>

<script>
import HeroSection from "@/components/layout/HeroSection";
export default {
  name: "WelcomeAlt",
  
  components: {
    HeroSection
  }
};
</script>
